export const stampImages = [
  { id: 0, src: '/card/stamp.svg', name: '' },
  { id: 1, src: '/card/stamp1.png', name: '' },
  { id: 2, src: '/card/stamp2.png', name: '' },
  { id: 3, src: '/card/stamp3.png', name: '' },
  { id: 4, src: '/card/stamp4.png', name: '' },
  { id: 5, src: '/card/stamp5.png', name: '' },
  { id: 6, src: '/card/stamp6.png', name: '' },
  { id: 7, src: '/card/stamp7.png', name: '' },
  { id: 8, src: '/card/stamp8.png', name: '' },
  { id: 9, src: '/card/stamp9.png', name: '' },
];

export const defaultBackgrounds = [
  { id: 1, url: '/card/temp1.png', thumbnail: '/card/temp1.png' },
  { id: 2, url: '/card/temp2.png', thumbnail: '/card/temp2.png' },
  { id: 3, url: '/card/temp3.png', thumbnail: '/card/temp3.png' },
  { id: 4, url: '/card/temp4.png', thumbnail: '/card/temp4.png' },
  { id: 5, url: '/card/temp5.png', thumbnail: '/card/temp5.png' },
  { id: 6, url: '/card/temp6.png', thumbnail: '/card/temp6.png' },
  { id: 7, url: '/card/temp7.png', thumbnail: '/card/temp7.png' },
  { id: 8, url: '/card/temp8.png', thumbnail: '/card/temp8.png' },
  { id: 9, url: '/card/temp9.png', thumbnail: '/card/temp9.png' },
  { id: 10, url: '/card/temp10.png', thumbnail: '/card/temp10.png' },
  { id: 11, url: '/card/temp11.png', thumbnail: '/card/temp11.png' },
  { id: 12, url: '/card/temp12.jpeg', thumbnail: '/card/temp12.jpeg' },
  { id: 13, url: '/card/temp13.jpeg', thumbnail: '/card/temp13.jpeg' },
  { id: 14, url: '/card/temp14.jpeg', thumbnail: '/card/temp14.jpeg' },
  { id: 15, url: '/card/temp15.jpeg', thumbnail: '/card/temp15.jpeg' },
  { id: 16, url: '/card/temp16.jpeg', thumbnail: '/card/temp16.jpeg' },
  { id: 17, url: '/card/temp17.jpeg', thumbnail: '/card/temp17.jpeg' },
  { id: 18, url: '/card/temp18.jpeg', thumbnail: '/card/temp18.jpeg' },
  { id: 19, url: '/card/temp19.jpeg', thumbnail: '/card/temp19.jpeg' },
  { id: 20, url: '/card/temp20.jpeg', thumbnail: '/card/temp20.jpeg' },
  { id: 21, url: '/card/temp21.jpeg', thumbnail: '/card/temp21.jpeg' },
  { id: 22, url: '/card/temp22.jpeg', thumbnail: '/card/temp22.jpeg' },
  { id: 23, url: '/card/temp23.jpeg', thumbnail: '/card/temp23.jpeg' },
  { id: 24, url: '/card/temp24.jpeg', thumbnail: '/card/temp24.jpeg' },
  { id: 25, url: '/card/temp25.jpeg', thumbnail: '/card/temp25.jpeg' },
  { id: 26, url: '/card/temp26.jpeg', thumbnail: '/card/temp26.jpeg' },
  { id: 27, url: '/card/temp27.jpeg', thumbnail: '/card/temp27.jpeg' },
  { id: 28, url: '/card/temp28.jpeg', thumbnail: '/card/temp28.jpeg' },
  { id: 29, url: '/card/temp29.jpeg', thumbnail: '/card/temp29.jpeg' },
  { id: 30, url: '/card/temp30.jpeg', thumbnail: '/card/temp30.jpeg' },
  { id: 31, url: '/card/temp31.jpeg', thumbnail: '/card/temp31.jpeg' },
  { id: 32, url: '/card/temp32.jpeg', thumbnail: '/card/temp32.jpeg' },
  { id: 33, url: '/card/temp33.jpeg', thumbnail: '/card/temp33.jpeg' },
  { id: 34, url: '/card/temp34.jpeg', thumbnail: '/card/temp34.jpeg' },
];



export const getStampById = (id) => {
  const stamp = stampImages.find((stamp) => stamp.id === id);
  return stamp ? stamp.src : null;
}

export const getBackgroundById = (id) => {
  const background = defaultBackgrounds.find((bg) => bg.id === id);
  return background ? background.url : null;
}